import { useEffect } from 'react'
import { useSelector } from 'react-redux'

import { createNotification } from '@/app/module/notifications/store/actions'
import { selectOrgId } from '@/app/module/user/store/selectors'
import { esApi, getErrorMessage } from '@/app/store/api'
import { useAppDispatch } from '@/app/store/redux-hooks'

export const useGetGroup = (groupId: number) => {
  const dispatch = useAppDispatch()
  const orgId = useSelector(selectOrgId)

  const res = esApi.endpoints.getOrgGroup.useQuery(
    { orgId: orgId.toString(), groupId: groupId.toString() },
    { skip: !orgId || !groupId },
  )

  useEffect(() => {
    if (!res.error) {
      return
    }
    dispatch(
      createNotification({
        'get-group-failure': {
          type: 'error',
          message: getErrorMessage(res.error, 'Failed to get contact group'),
        },
      }),
    )
  }, [res.error, dispatch])

  return res
}
